import type { GetApiCoursesCourseIdLecturesLectureId200ResourcesItemType } from './getApiCoursesCourseIdLecturesLectureId200ResourcesItemType';

export type GetApiCoursesCourseIdLecturesLectureId200ResourcesItem = {
  /** 자료 제목 */
  title?: string;
  type?: GetApiCoursesCourseIdLecturesLectureId200ResourcesItemType;
  /** 자료 URL */
  url?: string;
};
